import CountyLandingPage from "../components/CountyLandingPage";

const data = {
  slug: "los-angeles",
  region: "Los Angeles",
  metaTitle: "Los Angeles ADU Permit Toolkit",
  h1Prefix: "Los Angeles ADU permits,",
  h1Accent: "approved on the first submittal.",
  subtitle:
    "Generate a CALGreen-compliant Construction Waste Management Plan, Title 24 notes, and an AI-powered compliance memo tailored for the LA County Department of Public Works' submittal portal — all in under 10 minutes.",
  heroStats: [
    { value: "20%+", label: "of LA housing permits are now ADUs" },
    { value: "65%", label: "diversion required by CALGreen §5.408" },
    { value: "10 min", label: "from blank screen to council-ready PDF" },
  ],
  localRules: [
    {
      title: "LA County Public Works portal submittal",
      body: "Most LA County jurisdictions require waste-management documentation through the county's online portal alongside your permit application. Our memo references the portal explicitly so reviewers know exactly what they're getting.",
    },
    {
      title: "ADU streamlining ordinance (LAMC §12.22)",
      body: "Detached ADUs up to 1,200 sq ft are ministerially approved if they meet checklist criteria — but waste-plan paperwork still has to be flawless or the streamlined review stalls.",
    },
    {
      title: "City of LA Bureau of Sanitation hauler list",
      body: "Concrete and clean wood routes through the Bureau's authorised haulers fast-track diversion credit. Our facility list is pre-populated with current LA-area C&D recyclers.",
    },
    {
      title: "Title 24 Part 11 (CALGreen) energy + waste together",
      body: "The cover memo bundles waste compliance with Title 24 references so plan checkers don't have to chase two documents.",
    },
  ],
  painPoints: [
    "Submitting a generic CWMP that doesn't cite the LA County portal — instant rejection.",
    "Missing the 65% diversion math on drywall (LA's recycling infrastructure is thin — easy to fail without a plan).",
    "No subcontractor acknowledgement page — common reason for re-submittal.",
    "Forgetting the AB 939 / CALGreen §5.408 link — reviewers want both.",
    "Generic facility list with closed-down or non-LA recyclers — auto-flagged.",
  ],
  faqs: [
    {
      q: "Does Los Angeles County require a Construction Waste Management Plan for ADUs?",
      a: "Yes — under CALGreen §5.408 and most LA County local amendments, a CWMP is required for ADU permits with a target diversion of at least 65% by weight. Some cities within LA County have additional ordinances; our jurisdiction notes flag those.",
    },
    {
      q: "Can I use this for both LADBS and unincorporated LA County submittals?",
      a: "Yes. The plan and AI memo include language for both LA City (LADBS) and unincorporated LA County (Public Works). Pick your specific city in the wizard and the document adjusts.",
    },
    {
      q: "Is the AI compliance memo specific to Los Angeles?",
      a: "Yes — the memo references the LA County submittal portal, local hauler authorities, and the LAMC §12.22 streamlining context when the project county is Los Angeles.",
    },
    {
      q: "How fast can I get a permit-ready PDF?",
      a: "Most LA contractors finish in 6–12 minutes including the AI memo. Sign up, enter your project details, and download — only $59 for a one-off CWMP.",
    },
  ],
};

const CountyLAPage = () => <CountyLandingPage data={data} />;
export default CountyLAPage;
